import { useQuery } from "react-query";
import { api, ApiError } from "utils/api";
import { AdminReportResponse, AdminReportType } from "../types";

const getAdminReport = (
  report: AdminReportType,
  startDate: string,
  endDate: string
) => {
  const params = { report, startDate, endDate };
  const query = new URLSearchParams(params);
  return api(`/admin/reports?${query}`);
};

const useAdminReport = (
  report: AdminReportType,
  startDate: string,
  endDate: string
) =>
  useQuery<AdminReportResponse, ApiError>(
    ["admin-report", report, startDate, endDate],
    () =>
      getAdminReport(
        report,
        new Date(startDate).toISOString(),
        new Date(endDate).toISOString()
      )
  );

export { useAdminReport };
